import {AxiosError} from "axios";
import ErrorModel from "api/model/ErrorModel";

export const handleRequestError = (error: AxiosError, callback: (error: ErrorModel | undefined) => void) => {
    const errorModel = error.response?.data as ErrorModel;
    callback(errorModel);
}
